import { Box } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import LanguageMenu from "./LanguageMenu"
import { useTranslation } from "react-i18next"
import { STATICS } from "api/api"
import {ReactComponent as EstateToolLogo} from '/src/assets/svg/estatetool-logo.svg'
import { useBreak } from "hooks/useBreak"

export const Maintenance = () => {
    const { i18n, i18n: { language } } = useTranslation()
    const isDesktop                    = useBreak("md_up");
    
    return <Box sx={{ height: "100vh" }}>
        <Box sx={{ pt: { xs:2, lg: 5 }, px: { xs:2, lg: 5 }, height: { xs: "calc(100% - 50px)", lg: "calc(100% - 120px)" }, }}>
            <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: "space-between" }}>
                <Box            sx      = {{ height: { xs: 50, lg: 109 }, width: { xs: 100, lg: 229 } }}>
                    <EstateToolLogo style   = {{ width: '100%', height: '100%' }} />
                </Box>
               <Box sx = {{ position: 'relative', height: '100%'}}>
                 <LanguageMenu />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', height: "100%", justifyContent: "space-between", pt: { xs:2, lg: 0 } }}>
                <Box  sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', gap: '40px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box
                            component="img"
                            sx={{
                                // height: 233,
                                // width: 350,
                                // maxHeight: { xs: 233, md: 167 },
                                // maxWidth: { xs: 350, md: 250 },
                            }}
                            alt="maintenance-image"
                            src={`${STATICS}/svg/maintenance-image.svg`}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '16px' }}>
                        <h1 className={isDesktop ? 'h1' : `h3`}>{ maintenancePage.desc[language] }</h1>
                        <Box className="paragraph1-regular" sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '30px', maxWidth: "770px", alignSelf: 'center' }}>
                            <p>{ maintenancePage.p1[language] }</p>
                            <p>{ maintenancePage.p2[language] }</p>
                        </Box>
                    </Box>
                </Box>
                <PoweredBy />
            </Box>
        </Box>
    </Box>
}



const maintenancePage = {
    desc: {
        "en": "We're fine-tuning the details!",
        "da": "Vi finpudser lige detaljerne!"
    },
    p1: {
        "en": "The site is temporarily under maintenance while we work to improve your experience. We are updating and optimizing our product so that you can soon have access to an even better home selector.",
        "da": "Siden er midlertidigt under vedligeholdelse, mens vi arbejder på at forbedre din oplevelse. Vi opdaterer og optimerer vores produkt, så du snart kan få adgang til en endnu bedre boligvælger."
    },
    p2: {
        "en": "Thanks for your patience - we'll be back soon, and it will definitely be worth the wait!",
        "da": "Tak for din tålmodighed - vi er snart tilbage, og det bliver helt sikkert ventetiden værd!"
    }
}